export const getUsersApi = '/api/auth/'